import { render, staticRenderFns } from "./relatorio-pets-atendidos-unidade.vue?vue&type=template&id=c18fdc1c"
import script from "./relatorio-pets-atendidos-unidade.vue?vue&type=script&lang=js"
export * from "./relatorio-pets-atendidos-unidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports